/**
 * Pilot: detect a new frontend deploy without requiring a hard refresh.
 * Host nginx serves /app-build-id.json (written by deploy-pilot.sh after FE deploys).
 * Local dev: file absent — checks no-op.
 */

const BUILD_ID_URL = '/app-build-id.json';
const RELOAD_DEBOUNCE_KEY = 'accessiq_build_id_reload';
const RELOAD_DEBOUNCE_MS = 15000;
const POLL_MS = 10 * 60 * 1000;

let bootBuildId = null;

export async function fetchPilotBuildId() {
  try {
    const response = await fetch(BUILD_ID_URL, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'omit',
    });
    if (!response.ok) return null;
    const data = await response.json();
    const id = data && data.build_id != null ? String(data.build_id).trim() : '';
    return id || null;
  } catch {
    return null;
  }
}

function reloadForNewBuild() {
  const last = Number(sessionStorage.getItem(RELOAD_DEBOUNCE_KEY) || 0);
  if (Date.now() - last < RELOAD_DEBOUNCE_MS) return;
  sessionStorage.setItem(RELOAD_DEBOUNCE_KEY, String(Date.now()));
  window.location.reload();
}

export async function checkForNewPilotBuild() {
  const remote = await fetchPilotBuildId();
  if (!remote) return;
  if (bootBuildId === null) {
    bootBuildId = remote;
    return;
  }
  if (bootBuildId !== remote) {
    reloadForNewBuild();
  }
}

/** Start lightweight watch: tab focus + 10 min while visible. Returns cleanup fn. */
export function startPilotBuildIdWatch() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  checkForNewPilotBuild();

  const onVisible = () => {
    if (document.visibilityState === 'visible') {
      checkForNewPilotBuild();
    }
  };
  document.addEventListener('visibilitychange', onVisible);

  const intervalId = window.setInterval(() => {
    if (document.visibilityState === 'visible') {
      checkForNewPilotBuild();
    }
  }, POLL_MS);

  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    window.clearInterval(intervalId);
  };
}
